import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import {
  HealthProfilePageWrapper,
  MoreOptionsCard,
  AddAppsDevicesLink,
} from '@leagueplatform/health-profile-common';
import { Sidebar } from '@leagueplatform/web-common-components';
import { RewardsSidebarCard } from '@leagueplatform/rewards-achievements';
import { ManageUnitsLink } from '#components/manage-units-modal/index.ts';
import {
  usePageViewAnalytics,
  SUB_PRODUCT_AREA,
} from '@leagueplatform/analytics';
import { PRODUCT_AREA, SCREEN_NAMES } from '#constants/analytics.ts';
import { AllInsights } from '#components/insights/all-insights/all-insights.tsx';
import { useDocumentTitle } from '@leagueplatform/web-common';

export function InsightsPage() {
  const { formatMessage } = useIntl();

  const pageTitle = formatMessage({
    id: 'APP_AND_DEVICE_METRICS',
  });

  usePageViewAnalytics({
    product_area: PRODUCT_AREA.DASHBOARD,
    screen_name: SCREEN_NAMES.ALL_INSIGHTS,
    sub_product_area: SUB_PRODUCT_AREA.DASHBOARD,
  });

  useDocumentTitle(pageTitle);

  return (
    <HealthProfilePageWrapper
      title={pageTitle}
      sidebar={
        <Sidebar>
          <RewardsSidebarCard />
          <MoreOptionsCard>
            <AddAppsDevicesLink />
            <ManageUnitsLink />
          </MoreOptionsCard>
        </Sidebar>
      }
    >
      <AllInsights embedded={false} />
    </HealthProfilePageWrapper>
  );
}
